import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

// This is a minimal store just for UI state
export const useFundsStore = create(
  persist(
    (set) => ({
      // State
      funds: [],

      // Actions
      setFunds: (funds) => set({ funds }),
    }),
    {
      name: "mapex-funds-storage",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ funds: state.funds }),
    }
  )
);
